module.exports = __webpack_public_path__ + "media/warranty-claim/photos-vent3-42c9a58a.png";